import { CompleteStylistFragment } from 'drycut-graphql';
import StylistCheckInCard from './StylistCheckInCard';
import { useState } from 'react';

type Props = {
  stylists: CompleteStylistFragment[];
  onSelect: (stylist: CompleteStylistFragment) => void;
  storeSlug: string;
};
export function StylistCheckInGrid({ stylists, storeSlug, onSelect }: Props): React.ReactElement {
  const [selectedStylist, setSelectedStylist] = useState<CompleteStylistFragment | null>(null);

  // Order the stylists so that the ones with the most recent check-ins in the current store are first
  const sortedStylists = stylists.sort((a, b) => {
    const aCheckIn = a?.lastActionStore?.slug === storeSlug;
    const bCheckIn = b?.lastActionStore?.slug === storeSlug;

    if (!aCheckIn) {
      return 1;
    }

    if (!bCheckIn) {
      return -1;
    }

    return 0;
  });

  const handleSelect = (stylist: CompleteStylistFragment) => {
    setSelectedStylist(stylist);
    onSelect(stylist);
  };

  return (
    <div className="grid grid-cols-3 gap-4">
      {sortedStylists.map((stylist) => (
        <StylistCheckInCard
          key={stylist.id}
          stylist={stylist}
          onSelect={handleSelect}
          selected={selectedStylist === stylist}
        />
      ))}
    </div>
  );
}
